import { Col, Row, Label } from "reactstrap";
import React, { useEffect, useState } from "react";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import {
  staffHolidayCalendarCreate,
  staffHolidayCalendarCreateSuccess,
  staffHolidayCalendarList,
  staffHolidayCalendarUpdate,
  staffHolidayCalendarUpdateSuccess,
} from "../../../store/staffLeave/action";
import AppModal from "../../Common/AppModal";

export default function CreateEditStaffHolidayCalendarConfig({
  modal,
  setModal,
  toggle,
  isEdit,
  updateData,
}) {
  const dispatch = useDispatch();

  const initialData = {
    Name: "",
    Description: "",
    FlagAutoOpenUponRenewal: "0",
    DaysToOpenNextRenewal: "",
    StartDateDay: "",
    StartDateMonth: "",
    EndDateDay: "",
    EndDateMonth: "",
    QtyOfHoursInSingleDay: "",
    AllowedTimeBlockHours: "",
  };

  const [data, setData] = useState(initialData);

  useEffect(() => {
    if (!isEdit) return;
    if (isEmpty(updateData)) return;
    setData({
      Id: updateData?.Id,
      Name: updateData?.Name,
      Description: updateData?.Description ?? "",
      FlagAutoOpenUponRenewal: updateData?.FlagAutoOpenUponRenewal ?? "",
      DaysToOpenNextRenewal: updateData?.DaysToOpenNextRenewal ?? "",
      StartDateDay: updateData?.StartDateDay ?? "",
      StartDateMonth: updateData?.StartDateMonth ?? "",
      EndDateDay: updateData?.EndDateDay ?? "",
      EndDateMonth: updateData?.EndDateMonth ?? "",
      QtyOfHoursInSingleDay: updateData?.QtyOfHoursInSingleDay ?? "",
      AllowedTimeBlockHours: updateData?.AllowedTimeBlockHours ?? "",
    });
  }, [updateData, isEdit]);

  const handleCreateUpdateData = (type) => {
    // check Name
    if (isEmpty(data.Name)) {
      toast.error("Name is required");
      return;
    }
    // check QtyOfHoursInSingleDay
    if (isEmpty(data.QtyOfHoursInSingleDay)) {
      toast.error("Qty Of Hours In Single Day is required");
      return;
    }
    if (type === "create") {
      dispatch(staffHolidayCalendarCreate([data]));
    }
    if (type === "update") {
      dispatch(staffHolidayCalendarUpdate([data]));
    }
  };

  const {
    staffHolidayCalendarCreateSUCCESS,
    staffHolidayCalendarUpdateSUCCESS,
    staffHolidayCalendarUpdateLoading,
    staffHolidayCalendarCreateLoading,
  } = useSelector((state) => ({
    staffHolidayCalendarCreateSUCCESS:
      state.StaffLeave.staffHolidayCalendarCreate,
    staffHolidayCalendarUpdateSUCCESS:
      state.StaffLeave.staffHolidayCalendarUpdate,
    staffHolidayCalendarUpdateLoading:
      state.StaffLeave.staffHolidayCalendarUpdateLoading,
    staffHolidayCalendarCreateLoading:
      state.StaffLeave.staffHolidayCalendarCreateLoading,
  }));

  //Create
  useEffect(() => {
    if (isEmpty(staffHolidayCalendarCreateSUCCESS)) return;
    if (staffHolidayCalendarCreateSUCCESS.status === 200) {
      toast.success(staffHolidayCalendarCreateSUCCESS.message);
      setModal(false);
      dispatch(staffHolidayCalendarList());
    } else {
      toast.error(staffHolidayCalendarCreateSUCCESS.message);
    }
    dispatch(staffHolidayCalendarCreateSuccess([]));
  }, [staffHolidayCalendarCreateSUCCESS]);

  //Update
  useEffect(() => {
    if (isEmpty(staffHolidayCalendarUpdateSUCCESS)) return;
    if (staffHolidayCalendarUpdateSUCCESS.status === 200) {
      toast.success(staffHolidayCalendarUpdateSUCCESS.message);
      setModal(false);
      dispatch(staffHolidayCalendarList());
    } else {
      toast.error(staffHolidayCalendarUpdateSUCCESS.message);
    }
    dispatch(staffHolidayCalendarUpdateSuccess([]));
  }, [staffHolidayCalendarUpdateSUCCESS]);
  return (
    <AppModal
      open={modal}
      onClose={toggle}
      title={
        isEdit
          ? "Edit Period Staff Holiday Calendar"
          : "Create New Period Staff Holiday Calendar"
      }
      icon={<CalendarMonthOutlinedIcon />}
      headerAccent="indigo"
      size="sm"
      loading={
        staffHolidayCalendarUpdateLoading || staffHolidayCalendarCreateLoading
      }
      loadingText="Saving…"
      submitLabel={isEdit ? "Update" : "Create"}
      submitColor="success"
      onSubmit={() =>
        isEdit
          ? handleCreateUpdateData("update")
          : handleCreateUpdateData("create")
      }
    >
      <Row className="g-3">
            <Col lg={12}>
              <div className={"d-flex flex-column p-2"}>
                <Label>Name</Label>
                <input
                  type={"text"}
                  className={"form-control"}
                  value={data.Name}
                  onChange={(e) => setData({ ...data, Name: e.target.value })}
                />
              </div>
              <div className={"d-flex flex-column p-2"}>
                <Label>Description</Label>
                <input
                  className={"form-control"}
                  type={"text"}
                  value={data.Description}
                  onChange={(e) =>
                    setData({ ...data, Description: e.target.value })
                  }
                />
              </div>
              <div className={"d-flex flex-row p-2 align-items-center"}>
                <input
                  type={"checkbox"}
                  checked={data.FlagAutoOpenUponRenewal === "1"}
                  onChange={(e) =>
                    setData({
                      ...data,
                      FlagAutoOpenUponRenewal: e.target.checked ? "1" : "0",
                    })
                  }
                />
                <Label className={"m-0 p-0 ms-2"}>
                  Flag Auto Open Upon Renewal
                </Label>
              </div>
              <div className={"d-flex flex-column p-2"}>
                <Label>Days To Open Next Renewal</Label>
                <input
                  className={"form-control"}
                  type={"text"}
                  placeholder={"90"}
                  value={data.DaysToOpenNextRenewal}
                  onChange={(e) =>
                    setData({ ...data, DaysToOpenNextRenewal: e.target.value })
                  }
                />
              </div>{" "}
              <div className={"d-flex flex-column p-2"}>
                <Label>Start Date Day</Label>
                <input
                  className={"form-control"}
                  type={"text"}
                  placeholder={"1"}
                  value={data.StartDateDay}
                  onChange={(e) =>
                    setData({ ...data, StartDateDay: e.target.value })
                  }
                />
              </div>
              <div className={"d-flex flex-column p-2"}>
                <Label>Start Date Month</Label>
                <input
                  className={"form-control"}
                  type={"text"}
                  placeholder={"1"}
                  value={data.StartDateMonth}
                  onChange={(e) =>
                    setData({ ...data, StartDateMonth: e.target.value })
                  }
                />
              </div>
              <div className={"d-flex flex-column p-2"}>
                <Label>End Date Day</Label>
                <input
                  className={"form-control"}
                  type={"text"}
                  placeholder={"31"}
                  value={data.EndDateDay}
                  onChange={(e) =>
                    setData({ ...data, EndDateDay: e.target.value })
                  }
                />
              </div>
              <div className={"d-flex flex-column p-2"}>
                <Label>End Date Month</Label>
                <input
                  className={"form-control"}
                  type={"text"}
                  placeholder={"12"}
                  value={data.EndDateMonth}
                  onChange={(e) =>
                    setData({ ...data, EndDateMonth: e.target.value })
                  }
                />
              </div>
              <div className={"d-flex flex-column p-2"}>
                <Label>Qty Of Hours In SingleDay</Label>
                <input
                  className={"form-control"}
                  type={"text"}
                  placeholder={"7.5"}
                  value={data.QtyOfHoursInSingleDay}
                  onChange={(e) =>
                    setData({ ...data, QtyOfHoursInSingleDay: e.target.value })
                  }
                />
              </div>
              <div className={"d-flex flex-column p-2"}>
                <Label>Allowed Time Block Hours</Label>
                <input
                  className={"form-control"}
                  type={"text"}
                  placeholder={"0.25"}
                  value={data.AllowedTimeBlockHours}
                  onChange={(e) =>
                    setData({ ...data, AllowedTimeBlockHours: e.target.value })
                  }
                />
              </div>
              {/*[*/}
              {/*{*/}
              {/*    "Name": "{{$randomWords}}",*/}
              {/*    "Description": "{{$randomLoremParagraph}}",*/}
              {/*    "FlagAutoOpenUponRenewal": 1,*/}
              {/*    "DaysToOpenNextRenewal": 90,*/}
              {/*    "StartDateDay": 1,*/}
              {/*    "StartDateMonth": 1,*/}
              {/*    "EndDateDay": 31,*/}
              {/*    "EndDateMonth": 12,*/}
              {/*    "QtyOfHoursInSingleDay": 7.5*/}
              {/*}*/}
              {/*]*/}
            </Col>
          </Row>
    </AppModal>
  );
}
